import {
    isDillardsChargeEntered2
} from './_isDillardsCharge';

export const isDillardsGiftCard = (number) => {
    if (number.length > 0) {
        if (number.match(new RegExp("^[4,5,6]")) == null || number.length > 10) {
            if ($('form[name=QuickCheckoutCC2]').length > 0) {
                $("#newCard").prop("checked", true);
                $("#qcProfile2").hide();
                $("#newCards2").show();
                isDillardsChargeEntered2();
            }
            $('input[name=account]').on('focus', function() {
                document.body.scrollTop += this.getBoundingClientRect().top - 10;
            });
            $('input[name=giftCertificate]').val('');
            $('input[name=account]').val(number);
            $('input[name=account]').focus();
        }
    }
};
